import { createSignal } from 'solid-js';

type TranslationEnum = Record<string, string>;
type TranslationMap<T extends TranslationEnum> = Record<string, T>;

export type { TranslationEnum, TranslationMap };
export type TranslationKeysType<T extends TranslationEnum> = keyof T;

export function createTranslationKeys<T extends TranslationEnum>(_translationMap: TranslationMap<T>) {
  type Keys = keyof T;
  const keys = Object.keys(_translationMap[Object.keys(_translationMap)[0]]) as Keys[];
  return keys.reduce((acc, key) => {
    acc[key] = key;
    return acc;
  }, {} as Record<Keys, Keys>);
}

const STORAGE_KEY = 'language';
const [lang, setLang] = createSignal<string>((typeof window !== 'undefined' && localStorage.getItem(STORAGE_KEY)) || 'en');

export function useMagicLocalization<T extends TranslationEnum>(translationMap: TranslationMap<T>) {
  type LangCode = keyof typeof translationMap;
  type Keys = keyof T;
  const changeLanguage = (code: LangCode) => {
    localStorage.setItem(STORAGE_KEY, code as string);
    setLang(code as string);
  };

  const t = (key: Keys, params: Record<string, unknown> = {}) => {
    const currentTranslations = translationMap[lang() as LangCode];
    let text: string = currentTranslations[key] ?? String(key);
    for (const [k, v] of Object.entries(params)) {
      text = text.replaceAll(`{${k}}`, String(v));
    }
    return text;
  };

  return { t, changeLanguage, currentLanguage: lang };
}
